import React from "react"
import { render } from "react-dom"


class TextArea extends React.Component {
	handleChange = value => {
		this.props.onChange(this.props.name, value.target.value)
	}

	handleBlur = () => {
		this.props.onBlur(this.props.name, true)
	}

	render() {
		return (
			<textarea
				value={this.props.value}
				id={this.props.name}
				onChange={this.handleChange}
				onBlur={this.handleBlur}
				className={this.props.className}
			/>
		)
	}
}

export default TextArea
